import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

// F7 (backups track). Phase I (I-D): the Backups page is in the platform console; Data export stays in Settings.
export const routes: RouteObject[] = [];
export const orgRoutes: RouteObject[] = [];

// Phase I (I-D): Backups moved to the platform console (/platform/backups).
export const settingsRoutes: RouteObject[] = [
  // Track 5 (PLT-M15): full encrypted tenant export, for every tenant's administrators.
  { path: 'data-export', lazy: page(() => import('./data-export-page'), (m) => m.DataExportPage) },
];
